import { Image, Modal, Form, Carousel } from 'antd';
import classes from './Attachment.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';
import { ItemType } from 'antd/es/menu/interface';
import CustomInput from 'components/Messanger/CustomInput/CustomInput';
import { useAppSelector } from 'store/hook';

const message_length = window.REACT_APP_MESSAGE_LENGTH !== 'REPLACE_REACT_APP_MESSAGE_LENGTH' ? window.REACT_APP_MESSAGE_LENGTH : process.env.REACT_APP_MESSAGE_LENGTH; 
const MAX_LENGTH = Number(message_length) || 1000;

type Props = {
  attachment: File[];
  setAttachment: React.Dispatch<React.SetStateAction<File[]>>;
  onClose: (flag: boolean) => void;
  onFinish: () => Promise<void>;
  onOpenAttachment: () => void;
  tagsDocuments: ItemType[] | undefined;
};

function AttachmentModal({
  attachment,
  setAttachment,
  onClose,  
  onFinish,
  onOpenAttachment,
  tagsDocuments,
}: Props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [form] = Form.useForm();

  const { isAttachmentModalOpen } = useAppSelector((state) => state.chat);
  
  const editableModalRef = React.useRef<HTMLDivElement>(null);

  const { t } = useTranslation();  

  const onSend = async () => {    
    setIsLoading(true);
    await onFinish()
    setIsLoading(false);
  };

  const closeAttachment = () => onClose(true);

  return (
    <Modal
      title={t('Chats.modals.attachment.title')}
      onOk={form.submit}
      okText={t('Chats.modals.attachment.send')}
      onCancel={closeAttachment}
      open={isAttachmentModalOpen}
      className={cn(classes.mainWrap, getTheme())}
      classNames={{ body: classes.body }}
      loading={isLoading}
      confirmLoading={isLoading}
      
    >
      <Form form={form} onFinish={onSend} layout='vertical'>
        <Carousel className={classes.carousel}>
          {attachment.map((src, index) => (
            <div key={`image-${index}`} className={classes.container}>
              <Image
                className={classes.attachment}
                src={URL.createObjectURL(src)}
                alt='Attachment'
              />
            </div>
          ))}
        </Carousel>
        <Form.Item
          label={t('Chats.modals.attachment.subscription')}
          name={'message'}
          className={classes.customItem}
        >
          <CustomInput
            onFinish={onFinish}
            onOpenAttachment={onOpenAttachment}
            setAttachment={setAttachment}
            tagsDocuments={tagsDocuments}
            form={form}
            editableRef={editableModalRef}
            needToShowMenus={true}
            parent={'modal'}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AttachmentModal;
